module.exports = [
  {
    title: 'ID',
    key: 'id'
  },
  {
    title: 'Дата передачи',
    key: 'created_date'
  },
  {
    title: 'Время',
    key: 'time'
  },
  {
    title: 'Название МО',
    key: 'hospital'
  },
  {
    title: 'PatientID',
    key: 'patient_id'
  },
  {
    title: 'Сценарий использования',
    key: 'use_case'
  },
  {
    title: 'Регион',
    key: 'region'
  },
  {
    title: 'Уровень внимания',
    key: 'attention_level'
  },
  {
    title: 'Версия',
    key: 'api_version'
  },
  {
    title: 'Время запроса',
    key: 'response_time'
  }

]
